
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import szerb from "../../assets/szerb.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function SzerbMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Szerb magyar fordító</title>
                <meta name='description' content="Ingyenes szerb magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Szerb magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/szerb-magyar-fordito" />
            </Helmet>
            <h1>Szerb magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A szerb nyelvről</h2>
                    <img src={szerb} alt="Szerb zászló"></img>
                </div>

                <p>A szerb egy délszláv nyelv, amelyet elsősorban Szerbiában, Bosznia-Hercegovinában, Montenegróban, valamint Horvátország és Koszovó egyes részein beszélnek. Szerbia, Bosznia-Hercegovina és Montenegró egyik hivatalos nyelve. A szerb gazdag történelméről, egyedi ábécéjéről és a balkáni kulturális hatásáról ismert.</p>

                <p>Írásrendszere a cirill ábécét használja, amely 30 betűből áll. Megkülönböztető karaktereiről nevezetes, többek között Љ, Њ, Ћ, Ђ és Ј. A cirill betű mellett a szerb is írható latin ábécével. Mindkét írás hivatalosan elismert és széles körben használatos a szerb nyelvben.</p>

                <p>A szerb kiejtés általában fonetikus, ami azt jelenti, hogy a szavakat úgy ejtik ki, ahogy írják őket. Minden betűnek konzisztens hangja van, így viszonylag egyszerű megtanulni a szerb szavak kiejtését. Vannak azonban regionális eltérések az akcentusban és az intonációban.</p>

                <p>Nyelvtana főnévi ragozásokat, igeragozásokat és nyelvtani eseteket tartalmaz. A főnevek, melléknevek és névmások megváltoztatják alakjukat, hogy jelezzék a nemet, a számot és a kisbetűt. A szerbnek hét esete van: alany, genitivus, datívus, accusative, vocative, instrumental és locative. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>A szerb szókincs szláv gyökerekkel rendelkezik, de más nyelvekből, különösen törökből, németből és angolból is tartalmaz kölcsönszavakat. A szerb irodalom gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Ivo Andrić, Mesa Selimović és Danilo Kiš. A szerb kultúra sokszínű, történelme, vallása és regionális szokásai befolyásolják.</p>

                <p>A szerb nyelvtudás lehetőségeket nyit meg Szerbiában, Bosznia-Hercegovinában, Montenegróban és más szerb nyelvű régiókban. Szerbia fejlődő gazdasággal rendelkezik, és olyan iparágakban kínál kilátásokat, mint az IT, a gyártás, a turizmus és a mezőgazdaság. A szerb nyelv ismerete előnyös lehet ezeken a területeken végzett karrier vagy kulturális csere és együttműködés szempontjából.</p>

                <p>A szerb nyelv ismerete megkönnyíti a kommunikációt és a kulturális elmélyülést is a Balkánon. Lehetővé teszi a szerb történelem, hagyományok és társadalmi normák mélyebb megértését. Elősegíti a kapcsolatokat a szerb nyelvű közösségekkel, és gazdagítja a szomszédos országokban szerzett tapasztalatokat.</p>
            
                <div className="sectionbottom">
                    <Link to="/magyar-szerb-fordito">Magyar szerb fordító</Link>

                    <img src={szerb} alt="szerb zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>


            </section>
        </>

    )
}

export default SzerbMagyar;